import { useEffect, useState } from "react";
import Box from "elements/Box";
import { Fab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ApiRequest } from "GlobalFunctions";
import "assets/css/main.css";

export default function CitiesList(props: any) {
  const { setLoading } = props;

  const [list, setList] = useState<any[]>([]);
  const [searchCity, setSearchCity] = useState("");
  const [searchRegion, setSearchRegion] = useState("");
  const [filters, setFilters] = useState<any>({});
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const scrollEl = document.getElementById("main-content");
    if (!scrollEl) return;
    const handleScroll = () => setShowScrollTop(scrollEl.scrollTop > 300);
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    loadList();
  }, [filters]);

  // Debounce city filter
  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilters((prev: any) => {
        const f = { ...prev };
        if (searchCity.trim()) f["c.name"] = searchCity;
        else delete f["c.name"];
        return f;
      });
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchCity]);

  // Debounce region filter
  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilters((prev: any) => {
        const f = { ...prev };
        if (searchRegion.trim()) f["r.name"] = searchRegion;
        else delete f["r.name"];
        return f;
      });
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchRegion]);

  const loadList = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/locationCities/list",
      method: "get",
      headers: { ltkn: localStorage.getItem("ltkn") },
      query: { full_list: true, filters },
      setResponse: (response: any) => {
        setList(response.list);
        setLoading(false);
      },
    });
  };

  return (
    <div id="CitiesList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Ciudades</h2>
            <span className="h2_subtitle">Lista de ciudades</span>
          </div>
          <div className="boxContainerActions" style={{ display: "flex", gap: "10px" }}>
            <TextField
              label="Buscar Ciudad"
              size="small"
              value={searchCity}
              onChange={(e) => setSearchCity(e.target.value)}
            />
            <TextField
              label="Buscar Región"
              size="small"
              value={searchRegion}
              onChange={(e) => setSearchRegion(e.target.value)}
            />
          </div>
        </div>

        <Box id="CitiesListIn" className="box100">
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>CÓDIGO DANE</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>CIUDAD</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>REGIÓN</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover>
                    <TableCell>{item.dane_code}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.region_name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>

      {showScrollTop && (
        <Fab
          size="small"
          color="primary"
          onClick={() => {
            document.getElementById("main-content")?.scrollTo({ top: 0, behavior: "smooth" });
          }}
          sx={{ position: "fixed", bottom: 24, right: 24 }}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      )}
    </div>
  );
}
